import basicPlanPhoto from "@/assets/basicPlan.webp";
import proPlanPhoto from "@/assets/proPlan.webp";
import premiumPlanPhoto from "@/assets/premium.webp";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// import { useLoader } from "@/context/loaderContext";
// import api from "@/components/customAxios/Axios"
// type PlanName = "Free-Trial" | "Silver" | "Golden" | "Platinum";

// interface Plan {
// 	id: string;
// 	name: PlanName;
// 	amount: number;
// 	users_count: number;
// 	cv_count: number;
// 	assessment_count: number;
// 	duration_days: number;
// }

export default function Pricing() {
	const navigate = useNavigate();
	const [isPlanMonthly, setIsPlanMonthly] = useState(true);
	// const { setLoading } = useLoader()
	const register = () => {
		setIsPlanMonthly(true)
		navigate("/register");
	};
	// const planImages: Record<Exclude<PlanName, "Free-Trial">, string> = {
	// 	Silver: basicPlanPhoto,
	// 	Golden: proPlanPhoto,
	// 	Platinum: premiumPlanPhoto,
	// };

	// const planBestFor: Record<PlanName, string> = {
	// 	"Free-Trial": "For First-Time Users",
	// 	Silver: "For Small Business Owners",
	// 	Golden: "For Mid-Sized Companies",
	// 	Platinum: "For Large Enterprises",
	// };

	const plans = [
		{
			id: "",
			label: "Free-Trial",
			image: basicPlanPhoto,
			amount: 0,
			bestFor: "For First-Time Users",
			point: [
				"Single user",
				"10 Resumes Screening",
				"10 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
		{
			id: "",
			label: "Basic Plan",
			image: basicPlanPhoto,
			amount: 20,
			bestFor: "For Small Business Owners",
			point: [
				"Up to 5 users",
				"100 Resumes Screening",
				"25 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
		{
			id: "",
			label: "Pro Plan",
			image: proPlanPhoto,
			amount: 100,
			bestFor: "For Mid-Sized Companies",
			point: [
				"Up to 10 users",
				"800 Resumes Screening",
				"80 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
		{
			id: "",
			label: "Premium Plan",
			image: premiumPlanPhoto,
			amount: 200,
			bestFor: "For Large Enterprises",
			point: [
				"Up to 25 users",
				"1500 Resumes Screening",
				"200 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
	];

	return (
		<>
			<div className="min-h-[90vh] mt-28 mb-40">


				<div className="flex justify-center">
					<div className=" md:text-center space-y-5">
						<h2 className="text-4xl md:text-5xl font-semibold text-gray-800 mb-2 leading-normal md:leading-relaxed md:text-center text-left">
							Choose the Perfect Plan for <br className="hidden md:block" />
							your Hiring Needs
						</h2>
						<p className=" mt-4">
							Select from our flexible plans designed to fit the unique hiring needs of businesses of all sizes — from startups to large enterprises.
						</p>

						{/* <label className="inline-flex items-center cursor-pointer">
							<span className="me-3 text-sm font-medium text-gray-900 dark:text-gray-300">
								Monthly
							</span>
							<input
								onChange={() => setIsPlanMonthly((prev) => !prev)}
								type="checkbox"
								value=""
								className="sr-only peer"
							/>
							<div className="relative w-11 h-6 bg-white border   rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#9AB9B1] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-white dark:peer-checked:bg-blue-600"></div>
							<span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
								Yearly
							</span>
							<span className="mx-2 font-light text-[#568176]">-20% off</span>
						</label> */}
					</div>
				</div>
				<div className="flex justify-center items-center flex-wrap  gap-5 mt-5 mb-5">
					{plans.map((elem) => (
						<div
							className="w-72 rounded-2xl overflow-hidden shadow-md p-3 bg-white flex flex-col items-center"
							key={elem.label}
						>
							{/* Image */}
							<div className="w-full h-40 rounded-xl overflow-hidden relative mb-6">
								<img
									src={elem.image}
									alt="Basic Plan"
									className="object-cover w-full h-full"
								/>
								<div className="absolute inset-0 flex items-center justify-center ">
									<h2 className="text-white text-2xl font-semibold drop-shadow-xl">
										{elem.label}
									</h2>
								</div>
							</div>

							{/* Price */}
							<div className="flex items-end mb-2">
								<span className="text-3xl font-bold">
									${isPlanMonthly ? elem.amount : elem.amount * 10}
								</span>
								<span className="text-gray-500 text-lg font-semibold ml-1 mb-1">
									/{isPlanMonthly ? "month" : "year"}
								</span>
							</div>

							{/* Subtext */}
							<div className="text-gray-500 text-xs my-4  text-center border rounded-3xl px-5 py-2">
								{elem.bestFor}
							</div>

							{/* Whats included */}
							<div className="w-full mb-6">
								<h3 className="font-semibold text-base  mb-3 text-center">
									What's included
								</h3>
								<ul className="space-y-3 text-gray-700 text-sm">
									{elem.point.map((elem, index) => (
										<li className="flex items-center gap-2" key={index}>
											<span className="text-green-500">✓</span> {elem}
										</li>
									))}
								</ul>
							</div>

							{/* Button */}
							<button
								onClick={register}
								className={`
								
									 hover:bg-[#245045] hover:text-white
									 bg-[#F4F4F4] text-[#4A7D70]
							 w-full py-3 rounded-full  font-semibold  transition-all`}
							>
								Choose plan
							</button>
						</div>
					))}
				</div>
			</div>

		</>
		// <section className=" pricing mt-16 w-full">
		// 	{/* <h2 className="text-[3.5rem] text-[#3388CC] font-semibold  font-roboto flex justify-center mb-4 mt-[5rem]">Choose the plan that best fits your needs</h2> */}
		// 	<div
		// 		className="btn-group mx-auto block"
		// 		role="group"
		// 		aria-label="radio toggle button group"
		// 	>
		// 		<input
		// 			onChange={handleRadioClick}
		// 			type="radio"
		// 			className="btn-check"
		// 			name="vbtn-radio"
		// 			id="vbtn-radio1"
		// 			autoComplete="off"
		// 			checked={state === "monthly"}
		// 			value={pricings.monthly}
		// 		/>
		// 		<label
		// 			className="btn btn-outline-primary"
		// 			style={{ zIndex: "0" }}
		// 			htmlFor="vbtn-radio1"
		// 		>
		// 			Monthly
		// 		</label>
		// 		{/* <input
		// 			onChange={handleRadioClick}
		// 			type="radio"
		// 			className="btn-check"
		// 			name="vbtn-radio"
		// 			id="vbtn-radio2"
		// 			autoComplete="off"
		// 			value={pricings.quarterly}
		// 			checked={state === 'quarterly'}
		// 		/>
		// 		<label className="btn btn-outline-primary" htmlFor="vbtn-radio2">
		// 			Quarterly save 33%
		// 		</label> */}
		// 		{/* <input
		// 			onChange={handleRadioClick}
		// 			type="radio"
		// 			className="btn-check"
		// 			name="vbtn-radio"
		// 			id="vbtn-radio3"
		// 			autoComplete="off"
		// 			value={pricings.yearly}
		// 			checked={state === 'yearly'}
		// 		/>
		// 		<label className="btn btn-outline-primary" htmlFor="vbtn-radio3">
		// 			Yearly save 50%
		// 		</label> */}
		// 	</div>
		// 	<br />
		// 	<br />
		// 	<div className="" data-aos="fade-up">
		// 		<div className="pricing-grid my-5">
		// 			<div className="pricing-card">
		// 				<h3>Silver Plan</h3>
		// 				<br />
		// 				<h3>
		// 					<span className="line-through">$100</span> - ${silverPlan}
		// 					<sup> per user / month</sup>
		// 				</h3>
		// 				<br />
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />
		// 					&nbsp;AI Resume Matching
		// 				</p>
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />
		// 					&nbsp;AI Assessment Generation
		// 				</p>
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />{" "}
		// 					&nbsp;Single User Login
		// 				</p>
		// 				<br />
		// 				<p>
		// 					Ideal for: Small teams or solo recruiters looking to automate the
		// 					initial stages of the recruitment process.
		// 				</p>
		// 				<br />
		// 				<button
		// 					id="free-btn"
		// 					type="button"
		// 					className="btn btn-outline-primary"
		// 					onClick={() => setModalIsOpen(true)}
		// 				>
		// 					Contact us
		// 				</button>
		// 			</div>
		// 			<div className="pricing-card">
		// 				<h3>Gold Plan</h3>
		// 				<br />
		// 				<h3>
		// 					<span className="line-through">$1000</span> - ${goldPlan}
		// 					<sup>per user / month</sup>
		// 				</h3>
		// 				<br />
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />{" "}
		// 					No All Silver Plan features
		// 				</p>
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />{" "}
		// 					AI Assessment Evaluation
		// 				</p>
		// 				<p>
		// 					<i className="bi bi-check-circle" style={{ color: "#0b67bc" }} />{" "}
		// 					Full Multi-user Login (up to 7 users)
		// 				</p>
		// 				<br />
		// 				<p>
		// 					Ideal for: Growing teams requiring deeper analysis and
		// 					collaboration in their recruitment efforts.
		// 				</p>
		// 				<br />
		// 				<button
		// 					type="button"
		// 					className="btn btn-outline-primary"
		// 					onClick={() => setModalIsOpen(true)}
		// 				>
		// 					Contact Us
		// 				</button>
		// 			</div>
		// 			<div className="pricing-card" style={{}}>
		// 				<h3>Custom Plan- Talk to us</h3>
		// 				<h4 className="scroll-m-20 text-lg tracking-tight mt-4 mb-2">
		// 					Tailored solutions to fit your organisation's unique needs,
		// 					including advanced integration, unlimited user logins, and
		// 					priority support.
		// 				</h4>
		// 				<br />
		// 				<button
		// 					type="button"
		// 					className="btn btn-outline-primary"
		// 					onClick={() => setModalIsOpen(true)}
		// 				>
		// 					Contact Us
		// 				</button>
		// 			</div>
		// 		</div>
		// 	</div>
		// 	<Modal isOpen={modalIsOpen} style={customStyles}>
		// 		<div className="relative bg-white rounded-lg shadow-lg mx-auto p-6 overflow-auto my-3 md:my-0">
		// 			<button
		// 				onClick={() => setModalIsOpen(false)}
		// 				className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-3xl"
		// 				aria-label="Close"
		// 			>
		// 				&times;
		// 			</button>
		// 			<div className="text-center">
		// 				<h3 className="text-2xl font-bold text-blue-600">Let's Connect</h3>
		// 				<p className="text-gray-600 mt-2">
		// 					Contact our support team or make an appointment with our experts.
		// 				</p>
		// 			</div>
		// 			<form
		// 				className="mt-6 space-y-4"
		// 				action="https://getform.io/f/lbjnkgzb"
		// 				name="popupcontact"
		// 				method="POST"
		// 			>
		// 				<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
		// 					<div>
		// 						<label
		// 							htmlFor="fullname"
		// 							className="block text-zinc-700 dark:text-zinc-200 text-sm font-bold mb-2"
		// 						>
		// 							Full Name <span className="text-red-500">*</span>
		// 						</label>
		// 						<input
		// 							type="text"
		// 							id="fullname"
		// 							name="fullname"
		// 							className="shadow appearance-none border rounded w-full py-2 px-3 text-zinc-700 dark:text-zinc-300 leading-tight focus:outline-none focus:shadow-outline"
		// 							placeholder="Enter your full name"
		// 							required
		// 						/>
		// 					</div>
		// 					<div>
		// 						<label
		// 							htmlFor="email"
		// 							className="block text-zinc-700 dark:text-zinc-200 text-sm font-bold mb-2"
		// 						>
		// 							Email <span className="text-red-500">*</span>
		// 						</label>
		// 						<input
		// 							type="email"
		// 							id="email"
		// 							name="email"
		// 							className="shadow appearance-none border rounded w-full py-2 px-3 text-zinc-700 dark:text-zinc-300 leading-tight focus:outline-none focus:shadow-outline"
		// 							placeholder="Enter your email"
		// 							required
		// 						/>
		// 					</div>
		// 					<div>
		// 						<label
		// 							htmlFor="phone"
		// 							className="block text-zinc-700 dark:text-zinc-200 text-sm font-bold mb-2"
		// 						>
		// 							Phone Number <span className="text-red-500">*</span>
		// 						</label>
		// 						<input
		// 							type="tel"
		// 							id="phone"
		// 							name="phone number"
		// 							className="shadow appearance-none border rounded w-full py-2 px-3 text-zinc-700 dark:text-zinc-300 leading-tight focus:outline-none focus:shadow-outline"
		// 							placeholder="Enter your phone number"
		// 							required
		// 						/>
		// 					</div>
		// 				</div>
		// 				<div>
		// 					<label
		// 						htmlFor="subject"
		// 						className="block text-zinc-700 dark:text-zinc-200 text-sm font-bold mb-2"
		// 					>
		// 						Subject
		// 					</label>
		// 					<select
		// 						id="subject"
		// 						name="subject"
		// 						className="shadow appearance-none border rounded w-full py-2 px-3 text-zinc-700 dark:text-zinc-300 leading-tight focus:outline-none focus:shadow-outline"
		// 					>
		// 						<option value="" disabled>
		// 							Choose a plan...
		// 						</option>
		// 						<option>Silver Plan</option>
		// 						<option>Gold Plan</option>
		// 						<option>Custom Plan</option>
		// 					</select>
		// 				</div>
		// 				<div>
		// 					<label
		// 						htmlFor="message"
		// 						className="block text-zinc-700 dark:text-zinc-200 text-sm font-bold mb-2"
		// 					>
		// 						Message
		// 					</label>
		// 					<textarea
		// 						id="message"
		// 						name="description"
		// 						rows={5}
		// 						className="shadow appearance-none border rounded w-full py-2 px-3 text-zinc-700 dark:text-zinc-300 leading-tight focus:outline-none focus:shadow-outline"
		// 						placeholder="Write your message here..."
		// 						required
		// 					/>
		// 				</div>
		// 				<button
		// 					type="submit"
		// 					className="w-full bg-blue-600 text-white py-2 px-4 rounded-md shadow-sm hover:bg-blue-700 transition"
		// 				>
		// 					Send
		// 				</button>
		// 			</form>
		// 		</div>
		// 	</Modal>
		// </section>
	);
}
